import request from '@/utils/request'

const api_prefix = '/index'

// 获取系统配置
export function getHotSearch() {
    return request({
        url: api_prefix + '/gethotsearch',
        method: 'get',
    })
}

// 获取分类列表
export function getCategory() {
    return request({
        url: api_prefix + '/getcategory',
        method: 'get',
    })
}

// 获取轮播图
export function getCarousel() {
    return request({
        url: api_prefix + '/getcarousel',
        method: 'get',
    })
}

// 获取首页数据(最新、热门浏览、热门收藏、热门作者)
export function getHome() {
    return request({
        url: api_prefix + '/gethome',
        method: 'get',
    })
}

// 按照分类获取列表
export function getCategoryList(params) {
    return request({
        url: api_prefix + '/getbycategory',
        method: 'get',
        params
    })
}

// 按照关键词获取列表
export function getByName(params) {
    return request({
        url: api_prefix + '/getbyname',
        method: 'post',
        params
    })
}

// 获取课程详情
export function getCourse(id) {
    return request({
        url: api_prefix + '/getcourse',
        method: 'get',
        params: { id }
    })
}

// 获取课程详情
export function getCoursePayInfo(params) {
    return request({
        url: api_prefix + '/getpayinfo',
        method: 'post',
        params
    })
}

// 获取订单状态
export function getPayStatus(params) {
    return request({
        url: api_prefix + '/getorderstatus',
        method: 'post',
        params
    })
}

// 添加收藏
export function dolCollect(params) {
    return request({
        url: api_prefix + '/docollect',
        method: 'post',
        params
    })
}

// 获取用户课程列表
export function getUserCourseList(params) {
    return request({
        url: api_prefix + '/getusercourselist',
        method: 'post',
        params
    })
}

// 获取教学方向
export function getConfigs(params) {
    return request({
        url: api_prefix + '/getconfig',
        method: 'post',
        params
    })
}

// 申请退款
export function applyRefund(params) {
    return request({
        url: api_prefix + '/applyrefund',
        method: 'post',
        params
    })
}

